<template>
    <nav class="nav-wrapper" ref="nav" :class="{
        'bg1':targetIdx===0,
        'bg2':targetIdx===1,
        'bg3':targetIdx===2
        }">
        <ul class="share-wrapper fade2" :class="{'active': $parent.isfadeInActive}">
            <li>
                <a href="" class="link"
                @click.prevent="$parent.onShare('fb');gaEvent('share_fb', 'share_header');">
                    <img src="@/assets/images/tabs/btn_tab_5@2x.png" alt="FB分享"
                    v-show="!isPc">
                    <img src="@/assets/images/tabs/btn_tab_5@3x.png" alt="FB分享"
                    v-show="isPc">
                </a>
            </li>
            <li>
                <a :href="link" target="_blank" class="link"
                @click="gaEvent('buy_btn', 'buy_header');">
                    <img src="@/assets/images/tabs/btn_tab_4@2x.png" alt="返校購票"
                    v-show="!isPc">
                    <img src="@/assets/images/tabs/btn_tab_4@3x.png" alt="返校購票好學生"
                    v-show="isPc">
                </a>
            </li>
        </ul>
        <ul class="tab-wrapper fade1" :class="{'active': $parent.isfadeInActive}">
            <li v-for="(m, idx) in data"
            :key="idx"
            :class="{'active': isActive(m.id)}">
                <a href="" class="link"
                @click.prevent="goPageHandler(m);
                gaEvent('header_btn', gaObjList[idx]);" v-text="m.name">
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'MainNav',
    props: {
        isPc: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
        },
        link: {
            type: String,
        },
        targetIdx: {
            type: Number,
        },
    },
    data() {
        return {
            gaObjList: ['issue1_header', 'issue2_header', 'issue3_header'],
        };
    },
    mounted() {
    },
    methods: {
        filp(callback) {
            this.$emit('filp', callback);
        },
        goPageHandler(data) {
            const {
                id, date, remind,
            } = data;
            const now = new Date();
            const magzDate = date ? new Date(date) : 0;
            const msg = remind || '校刊暫不開放';

            if (!id || !magzDate || now < magzDate) {
                this.commonAlert(msg);
                return;
            }

            if (this.$route.query.id !== `${id}`) {
                this.filp(() => {
                    window.scrollTo(0, 0);
                    this.goPage(`/?id=${id}`);
                });
            }
        },
        isActive(id) {
            if (this.$parent.targetId) {
                return this.$parent.targetId === id;
            }
            if (this.data && this.data.length) {
                return id === this.data[0].id;
            }
            return false;
        },
    },
    mixins: [mixinMethod],
};
</script>
